import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useQuery } from "../_app/lib/query";
import { getPaymentDetails, postPaymentDetails, putPaymentDetails } from "./api";
import { PaymentDetails } from "./types";
import { useFeedbackAlerts } from "../_app/hooks";
import { useContextProvider } from "../context/providers/ContextProvider";

export function usePaymentDetails(options = {}) {
  const { contextId: accountId } = useContextProvider();
  return useQuery({
    queryKey: ["paymentDetails", accountId],
    queryFn: () => getPaymentDetails(accountId),
    staleTime: 0,
    enabled: Boolean(accountId),
    ...options,
  });
}

export function usePaymentDetailsUpdate(options = {}) {
  const queryClient = useQueryClient();
  const { setFeedbackAlertError, setFeedbackAlertSuccess } = useFeedbackAlerts();
  const { contextId: accountId } = useContextProvider();
  return useMutation({
    mutationFn: (details: PaymentDetails) => putPaymentDetails(details, accountId),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["paymentDetails", accountId] });
      setFeedbackAlertSuccess("Payment Details changed.");
    },

    onError: (error: any) => {
      setFeedbackAlertError(error?.data?.message);
    },

    ...options,
  });
}

export function usePaymentDetailsCreate(options = {}) {
  const { contextId: accountId } = useContextProvider();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (details: PaymentDetails) => postPaymentDetails(details, accountId),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["paymentDetails", accountId] });
    },

    ...options,
  });
}
